<h4 id="customerpage">customer works!</h4>
<button id="getCustomersButton" (click)="showConfig()">GetCustomer</button>
<h4 id="getcustomer">{{customer.name}} logged in!!!</h4>
